'use strict';
import * as $j_app$002edata$002e$002dApp$002dAuth$002dData from "./app.data.-App-Auth-Data.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppAuthData$() {
  this.axt = null;
  this.axr = null;
  this.axs = false;
  $n_Lapp_data_AppAuthData$ = this;
  this.axt = new $j_app$002edata$002e$002dApp$002dAuth$002dData.$c_Lapp_data_AppAuthData("<for-uri>");
}
export { $c_Lapp_data_AppAuthData$ as $c_Lapp_data_AppAuthData$ };
$p = $c_Lapp_data_AppAuthData$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppAuthData$;
/** @constructor */
function $h_Lapp_data_AppAuthData$() {
}
export { $h_Lapp_data_AppAuthData$ as $h_Lapp_data_AppAuthData$ };
$h_Lapp_data_AppAuthData$.prototype = $p;
$p.kt = (function() {
  if ((!this.axs)) {
    this.axr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lsttp_tapir_Codec__map__F1__F1__Lsttp_tapir_Codec($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lsttp_tapir_Codec$().hY, new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((s) => {
      $m_Lapp_data_AppAuthData$();
      return new $j_app$002edata$002e$002dApp$002dAuth$002dData.$c_Lapp_data_AppAuthData(s);
    })), new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((_$1) => _$1.Xx)));
    this.axs = true;
  }
  return this.axr;
});
$p.bK0 = (function(x$0) {
  return new $j_app$002edata$002e$002dApp$002dAuth$002dData.$c_Lapp_data_AppAuthData(x$0.e(0));
});
$p.U = (function(p) {
  return this.bK0(p);
});
var $d_Lapp_data_AppAuthData$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppAuthData$, "app.data.AppAuthData$", ({
  z8: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_data_AppAuthData$ as $d_Lapp_data_AppAuthData$ };
var $n_Lapp_data_AppAuthData$;
function $m_Lapp_data_AppAuthData$() {
  if ((!$n_Lapp_data_AppAuthData$)) {
    $n_Lapp_data_AppAuthData$ = new $c_Lapp_data_AppAuthData$();
  }
  return $n_Lapp_data_AppAuthData$;
}
export { $m_Lapp_data_AppAuthData$ as $m_Lapp_data_AppAuthData$ };
//# sourceMappingURL=app.data.-App-Auth-Data$.js.map
